<div class="flex w-full items-center justify-center gap-0">
  <div class="col-spinner">
    <div class="wrapper-spinner">
      <mat-spinner
        [color]="customer() === false ? 'accent' : ''"
        [class.mat-spinner-customer]="customer() === true" />
    </div>
  </div>
</div>
